import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './accessibility.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { isNativeMobile } from './utils/platform';

// Add native-mobile class to body for platform-specific CSS
if (isNativeMobile()) {
  document.body.classList.add('native-mobile');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register service worker for PWA support
serviceWorkerRegistration.register();
